<div class="footer" [ngClass]="{'arabic': lang === 'ar'}">
  <div class="container">
     <div class="row">
      <div class="col-lg-8">
        <img class="d-block mb-5 footer-logo" src="./assets/images/svg-icons/logo.svg" alt="" width="130px">
        <p class="font-16 wx-200 text-white my-4 footer-address" translate>footer_address</p>
        <div class="d-flex align-items-cente justify-content-center justify-content-lg-start  mt-4 mt-lg-0">
          <a href="https://twitter.com/XRP_20" target="_blank" class="mx-2">
            <img src="./assets/images/svg-icons/social-icons/twitter-blue.svg" alt="">
          </a>
          <a href="https://t.me/XRP20_coin" target="_blank" class="mx-2">
            <img src="./assets/images/svg-icons/social-icons/telegram-blue.svg" alt="">
          </a>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="my-md-3 footer-nav">
          <a class="text-white d-block" *ngFor="let item of navigations" href="javascript:void(0)"(click)="navigateToSection(item.routeName);" title="{{item.routeName}}" translate>{{item.navName}}</a>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="my-md-3 footer-nav">
          <a *ngFor="let item of policies" href="{{item.link}}" target="_blank" class="text-white d-block" translate>{{item.navName}}</a>
          
        </div>
      </div>
      <div class="col-12">
        <div class="text-center text-lg-start wd-100 font-14 mt-4 mb-0" translate>footer_head</div>
      </div>
    </div>
    <hr/>
    <div class="row">
      <div class="col-lg-6">
        <a href="mailto:contact@xrp20coin.com" target="_blank" class="mb-lg-0 mb-3 text-center d-block text-lg-start text-lowercase text-white" translate>email</a>
      </div>
      <div class="col-lg-6">
        <div class="mb-lg-0 mb-3 text-center text-lg-end font-14 fw-regular">{{"copyright" | translate}}</div>
      </div>
    </div>
  </div>
</div>
